const COMMON_EMAIL_DOMAINS = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com",
  "outlook.com",
  "icloud.com",
  "aol.com",
  "live.com",
];
function levenshteinDistance(source, target) {
  const sourceLength = source.length;
  const targetLength = target.length;
  if (source === target) return 0;
  if (sourceLength === 0) return targetLength;
  if (targetLength === 0) return sourceLength;
  const previousRow = new Array(targetLength + 1);
  const currentRow = new Array(targetLength + 1);
  for (let column = 0; column <= targetLength; column += 1) {
    previousRow[column] = column;
  }
  for (let row = 1; row <= sourceLength; row += 1) {
    currentRow[0] = row;
    for (let column = 1; column <= targetLength; column += 1) {
      const substitutionCost = source[row - 1] === target[column - 1] ? 0 : 1;
      const insertion = currentRow[column - 1] + 1;
      const deletion = previousRow[column] + 1;
      const substitution = previousRow[column - 1] + substitutionCost;
      currentRow[column] = Math.min(insertion, deletion, substitution);
    }
    for(let column = 0; column <= targetLength; column += 1){
      previousRow[column] = currentRow[column];
    }
  }
  return previousRow[targetLength];
}
export function getSuggestedEmail(inputEmail){
  if (typeof inputEmail !== "string") return null;
  const trimmedEmail = inputEmail.trim();
  if (!trimmedEmail) return null;
  const atIndex = trimmedEmail.lastIndexOf("@");
  if(atIndex <= 0 || atIndex === trimmedEmail.length - 1) return null;
  const localPart = trimmedEmail.slice(0, atIndex);
  const domainPart = trimmedEmail.slice(atIndex + 1).toLowerCase();
  let bestMatch = null;
  let bestDistance = Number.POSITIVE_INFINITY;
  for (const knownDomain of COMMON_EMAIL_DOMAINS) {
    if (domainPart === knownDomain) return null;
    const distance = levenshteinDistance(domainPart, knownDomain);
    if (distance < bestDistance) {
      bestDistance = distance;
      bestMatch = knownDomain;
    }
  }
  if(bestDistance === 1 || bestDistance === 2){
    return `${localPart}@${bestMatch}`;
  }
  return null;
}
export { COMMON_EMAIL_DOMAINS, levenshteinDistance };
